import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bjzjys-2",
  "use": "icon-bjzjys-2-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol viewBox=\"0 0 42 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bjzjys-2\">\n<rect x=\"0.166992\" y=\"0.166504\" width=\"41.6667\" height=\"41.6667\" rx=\"20.8333\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol